import React from 'react';
import { get } from 'lodash';
import { object, func, bool } from 'prop-types';
import { Modal } from 'antd';
import { Text, FlexContainer, Row, IconContainer, Icon, Button } from '../../common';

const ModalConfirmation = ({ onClose, pollSelected, visible }) => {
    const closeModal = () => onClose();

    return <Modal
        footer={<Row justify='flex-end'>
            <Button
                text='Cerrar'
                width={85}
                secondary
                onClick={onClose}
            />
        </Row>}
        title='Obligatoridad'
        visible={visible}
        onCancel={closeModal}
    >
        <FlexContainer style={{ marginBottom: 20 }} direction='column' align='center'>
            <IconContainer color='#ffffff' size={70}>
                <Icon name='caution' color='#D60000' size={46.8} />
            </IconContainer>
            <Text text={'Encuesta no tiene tiendas asociadas.'} />
            <Text text={get(pollSelected, 'namePoll')} strong />
        </FlexContainer>
    </Modal>;
};

ModalConfirmation.propTypes = {
    onClose: func,
    visible: bool,
    pollSelected: object
};

export default ModalConfirmation;
